module.exports = __webpack_public_path__ + "assets/img/help_image03-3@2x.f02370a7.png";